import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col items-center gap-6">
          {/* Legal Links */}
          <nav className="flex flex-col md:flex-row items-center gap-4 md:gap-2 text-sm">
            <Link 
              to="/politica-de-privacidad" 
              className="text-gray-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              Política de Privacidad
            </Link>
            <span className="hidden md:inline text-gray-600">|</span>
            <Link 
              to="/politica-de-cookies" 
              className="text-gray-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              Política de Cookies
            </Link>
            <span className="hidden md:inline text-gray-600">|</span>
            <Link 
              to="/aviso-legal" 
              className="text-gray-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              Aviso Legal
            </Link>
          </nav>

          {/* Copyright */}
          <div className="text-center">
            <p className="text-sm text-gray-400 mb-2">
              {t('footer.copyright')}
            </p>
            <p className="text-sm text-gray-500">
              {t('footer.credit')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}